export const getQueryParm = (key: string, defaultValue: string = ''): string => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    return urlParams.get(key.toLowerCase()) ?? defaultValue;
};
